// import { xcxWaterPage, xcxMedicationPage, xcxEnvironmentPage, xcxExaminingPage, } from '@/service/indexIcon'
export const FIELDS = {
  waterRequest: {
    promt: '这是我提交的水质监测记录，请对比分析该批次下目标系统的上述养殖记录数据，给出养殖优化建议或经验， 以Markdown格式结构化呈现',
    showView: {
      "title": '每日水质监测记录',
      "溶氧": 'o2',
      "ph": 'ph',
      "水温": 't',
      "臭氧": 'o3',
      "氨氮": 'tan',
      "亚硝酸盐": 'no2n',
      "硝酸盐": 'no3n',
      "化学需氧量": 'cod',
      "总溶解固体量": 'tds',
      "总悬浮固体量": 'tss',
      "总氮": 'tn',
      "总磷": 'tp',
      "总碱度": 'kh',
      "总硬度": 'gh',
      "余氯": 'ci',
      "水位": 'waterMark',
      "水量": 'waterYield',
      "水流速": 'waterSpeed',
      "色度": 'chroma',
      "浑浊度": 'turbidity',
      "水质风险": 'waterResult',
      "检测位置": 'location',
    },

    currentData: {},
    historyData: {},
    extraData: [
      { key: 'systemCode', text: '系统编码' },
      { key: 'batchCode', text: '批次编码' },

    ],
    filteredData: ['uploadFiles']
    // queryParams: {
    //   page: 1,
    //   limit: 10,
    // },
    // queryRequest: xcxWaterPage,
  },
  medicationRequest: {
    // queryRequest: xcxMedicationPage,
    promt: '这是我提交的每日用药记录，请对比分析该批次下目标系统的历史养殖记录数据，给出养殖优化建议或经验， 以Markdown格式结构化呈现。',
    showView: {
      "title": '每日用药记录',
      "用药名称": "medicine",
      "剂量": "dosage",
      "用途": "purpose",
      "单位": "unit",
    },
    currentData: {},
    historyData: {},
    extraData: [
      { key: 'systemCode', text: '系统编码' },
      { key: 'batchCode', text: '批次编码' },

    ],
    filteredData: ['uploadFiles']
    // queryParams: {
    //   page: 1,
    //   limit: 10,
    // },
  },
  growthSituationRequest: {
    // queryRequest: xcxExaminingPage,
    promt: '这是我提交的生长记录，请对比分析该批次下目标系统的历史养殖记录数据，给出养殖优化建议或经验， 以Markdown格式结构化呈现。',
    showView: {
      "title": '每日生长记录',
      "检测结果": "examiningResult",
      "取样数量": "sampling",
      "平均重量": "averageWeight",
      "平均长度": "averageLength",
      "平均规格": "averageSpec",
    },
    currentData: {},
    historyData: {},
    extraData: [
      { key: 'systemCode', text: '系统编码' },
      { key: 'batchCode', text: '批次编码' },

    ],
    filteredData: ['uploadFiles']
    // queryParams: {
    //   page: 1,
    //   limit: 10,
    //   state: 'growth'
    // },
  },
  healthRecordRequest: {
    // queryRequest: xcxExaminingPage,
    promt: '这是我提交的健康记录，请对比分析该批次下目标系统的历史养殖记录数据，给出养殖优化建议或经验， 以Markdown格式结构化呈现。',
    showView: {
      "title": '每日健康记录',
      "检测结果": "examiningResult",
      "体态": "posture",
      "体色": "bodyColour",
      "消化情况": "digestion",
      "吃料情况": "feeding",
      "粪便颜色": "stoolColor",
      "粪便状态": "stoolState",
      "活力": "vitality",
    },
    currentData: {},
    historyData: {},
    extraData: [
      { key: 'systemCode', text: '系统编码' },
      { key: 'batchCode', text: '批次编码' },

    ],
    filteredData: ['uploadFiles']
    // queryParams: {
    //   page: 1,
    //   limit: 10,
    //   state: 'health'
    // },
  },

  inspectionReportRequest: {
    // queryRequest: xcxExaminingPage,
    promt: '这是我提交的环检验记录，请对比分析该批次下目标系统的历史养殖记录数据，给出养殖优化建议或经验， 以Markdown格式结构化呈现。',
    showView: {
      "title": '每日检验记录',
      "检测结果": "examiningResult",
      "阶段": "stage",
      "检疫内容": "content",
    },
    currentData: {},
    historyData: {},
    extraData: [
      { key: 'systemCode', text: '系统编码' },
      { key: 'batchCode', text: '批次编码' },

    ],
    filteredData: ['uploadFiles']
    // queryParams: {
    //   page: 1,
    //   limit: 10,
    //   state: 'inspection'
    // },
  },
  environmentRecordRequest: {
    // queryRequest: xcxEnvironmentPage, 
    promt: '这是我提交的环境调控记录，请对比分析该批次下目标系统的历史养殖记录数据，给出养殖优化建议或经验， 以Markdown格式结构化呈现。',
    showView: {
      "title": '每日环控记录',
      "水位": "waterMark",
      "水量": "waterYield",
      "空气湿度": "airHumidity",
      "空气温度": "airTemperature",
      "气压": "barometricPressure",
      "天气": "weather",
    },
    currentData: {},
    historyData: {},
    extraData: [
      { key: 'systemCode', text: '系统编码' },
      { key: 'batchCode', text: '批次编码' },

    ],
    filteredData: ['uploadFiles'],
    exclude: ['title']
    // queryParams: {
    //   page: 1,
    //   limit: 10,
    // },

  },
  _feedingRequest: {
    promt: '这是我提交的每日投喂记录，请对比分析该批次下目标系统的上述养殖记录数据，给出养殖优化建议或经验， 以Markdown格式结构化呈现',
    showView: {},
    extraData: [
      { key: 'systemCode', text: '系统编码' },
      { key: 'batchCode', text: '批次编码' },

    ],
    currentData: {},
    holdFeilds: ['baitName', 'title', 'weight', 'fishpondCode',],
  },
  _lossRequest: {
    promt: '这是我提交的养殖损耗记录，请对比分析该批次下目标系统的上述养殖记录数据，给出养殖优化建议或经验， 以Markdown格式结构化呈现',
    showView: {},
    extraData: [
      { key: 'systemCode', text: '系统编码' },
      { key: 'batchCode', text: '批次编码' },

    ],
    currentData: {},
    holdFeilds: ['fishpondCode', 'lossWeight', 'lossCount'],
  },
    _aquaMedication: {
    // queryRequest: xcxMedicationPage,
    promt: '这是我提交的每日用药记录，请对比分析该批次下目标系统的历史养殖记录数据，给出养殖优化建议或经验， 以Markdown格式结构化呈现。',
   showView: {},
    extraData: [
      { key: 'systemCode', text: '系统编码' },
      { key: 'batchCode', text: '批次编码' },

    ],
    currentData: {},
    holdFeilds: ['medicine', 'method', 'unit', 'dosage', 'purpose'],
  },
  microscopicRequest: {
    // queryRequest: xcxEnvironmentPage, 
    promt: '这是我提交的镜检记录，请对比分析该批次下目标系统的历史养殖记录数据，给出养殖优化建议或经验， 以Markdown格式结构化呈现。',
    showView: {
      "title": '镜检记录',
      "检测结果": "examiningResult",
      "检验对象": "microObject",
      "病原情况": "microCase",
    },
    currentData: {},
    historyData: {},
    extraData: [
      { key: 'systemCode', text: '系统编码' },
      { key: 'batchCode', text: '批次编码' },

    ],
    filteredData: ['uploadFiles'],
    exclude: ['title']
    // queryParams: {
    //   page: 1,
    //   limit: 10,
    // },

  },
};











